import React, { Component } from 'react'
import { api } from '../../../services'

import { Modal, Upload, Button, message, Alert } from 'antd'

export default class extends Component {
  handleCancel = (e) => {
    const { closeModal, setTable } = this.props

    setTable([], [])
    closeModal()
  }

  onChange = (info) => {
    const { updateStorageFile } = this.props
    const { status, response } = info.file

    if (status === 'done') {
      if (response && !response.error) {
        updateStorageFile(response.result)
      }
    } else if (status === 'error' && !info.file.before) {
      message.error(`${info.file.name} file upload failed.`)
    }
  }

  beforeUpload (file) {
    const isLt2GB = file.size / 1024 / 1024 < 200
    if (!isLt2GB) {
      file.status = 'error'
      file.before = true
      message.error('File must be smaller than 200Mb!')
    }
    return isLt2GB
  }

  render () {
    const { status, storage } = this.props

    const guid = storage.table.rows.length > 0 ? storage.table.rows[0].guid : null

    const uploadProps = {
      name: 'file',
      multiple: false,
      data: (file) => {
        return {
          name: file.name.replace(/\.[^/.]+$/, '')
        }
      },
      customRequest ({
        data,
        file,
        filename,
        onError,
        onProgress,
        onSuccess
      }) {
        const formData = new FormData()
        if (data) {
          Object.keys(data).map(key => formData.append(key, data[key]))
        }
        formData.append(filename, file)

        api.storage.update(guid, formData, file, onProgress)
          .then(({ data: response }) => {
            onSuccess(response, file)
          })
          .catch(onError)

        return {
          abort () {
            console.log('Upload progress is aborted.')
          }
        }
      }
    }

    return (
      <Modal
        wrapClassName='vertical-center-modal'
        title='Update File'
        visible={status}
        onCancel={this.handleCancel}
        footer={null}
        destroyOnClose
      >
        <Alert type='info' message='If this file is used in Collections and Shares, it will be updated automatically in all those places' style={{ marginBottom: '2rem' }} />
        <Upload.Dragger
          {...uploadProps}
          beforeUpload={this.beforeUpload}
          onChange={this.onChange}
          accept={storage.table.rows.length === 1 ? `.${storage.table.rows[0].extension}` : null}>
          <div className='dragger'>
            <div className='dragger__heading'>Drag & Drop file here or</div>
            <div className='dragger__control'><Button type='indigo'>Select file</Button></div>
          </div>
        </Upload.Dragger>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Modals/StorageUpdateModal/StorageUpdateModal.jsx